import { useEsigningProviders } from 'app/domains/esigning/hooks/useEsigningProviders';
export function useEsigningAuthenticationModes() {
    const { connectedProvider } = useEsigningProviders();
    return { authenticationModes: (connectedProvider === null || connectedProvider === void 0 ? void 0 : connectedProvider.authenticationModes) || [] };
}
